import React from 'react';
import './Top.scss'
export interface UHCSidebarTopProps {
    children: React.ReactNode;
}

const UHCSidebarTop: React.FC<UHCSidebarTopProps> = (props: UHCSidebarTopProps) => {

    return(
        <div data-testid="sidebar-top" className="sidebar-top" >
            {props.children}
        </div>
    )
}

export default UHCSidebarTop;